<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <!-- List template -->
            <b-card border-variant="light" class="card-doc">
                <b-card-title class="font-18 font-weight-bold"
                    >Danh sách cấu hình tin nhắn</b-card-title
                >
                <b-table
                    class="mt-2"
                    striped
                    hover
                    :items="listTemps"
                    :fields="tempFields"
                    show-empty
                    :current-page="currentTempPage"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                >
                    <template v-slot:cell(index)="data">{{
                        (currentTempPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                    }}</template>
                    <template v-slot:cell(createdAt)="data">
                        <span>{{ data.value | formatDateTime }}</span>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge
                            class="px-2 py-1 font-12"
                            :variant="row.item.status === 'SUCCESS' ? 'success' : 'secondary'"
                            >{{
                                row.item.status === 'SUCCESS' ? 'THÀNH CÔNG' : 'THẤT BẠI'
                            }}</b-badge
                        >
                    </template>
                    <template #cell(actions)="row">
                        <b-button
                            variant="primary"
                            class="mr-1 min-width-none"
                            @click="showUpdateTempModal(row.item.id)"
                            v-b-tooltip.hover
                            :title="$t('common.edit')"
                        >
                            <i class="fa fa-pencil"></i>
                        </b-button>
                    </template>
                    <template v-slot:empty>
                        <div class="text-center">
                            <span>Không tìm thấy bản ghi nào</span>
                        </div>
                    </template>
                </b-table>
                <div v-if="totalTempRows > CONSTANTS.AUDIT_ITEM_PER_PAGE" class="my-1">
                    <b-pagination
                        v-model="currentTempPage"
                        :total-rows="totalTempRows"
                        :per-page="CONSTANTS.AUDIT_ITEM_PER_PAGE"
                        :hide-goto-end-buttons="true"
                        :prev-text="$t('common.prevPage')"
                        :next-text="$t('common.nextPage')"
                        class="my-0"
                        align="center"
                    />
                </div>
            </b-card>

            <!-- List users -->
            <b-card border-variant="light" class="card-doc">
                <b-row>
                    <b-col>
                        <b-card-title class="font-18 font-weight-bold">
                            Danh sách người nhận tin</b-card-title
                        >
                    </b-col>
                    <b-col class="text-right">
                        <b-button variant="outline-primary" @click="openCreateModal">
                            <i class="fa fa-plus-circle mr-2"></i>
                            <span class="text-uppercase">Thêm người nhận</span>
                        </b-button>
                    </b-col>
                </b-row>

                <b-table
                    class="mt-2"
                    striped
                    hover
                    :items="listUsers"
                    :fields="userFields"
                    show-empty
                    :current-page="currentUserPage"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                >
                    <template v-slot:cell(index)="data">{{
                        (currentUserPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                    }}</template>
                    <template v-slot:cell(createdAt)="data">
                        <span>{{ data.value | formatDateTime }}</span>
                    </template>
                    <template #cell(actions)="row">
                        <b-button
                            variant="primary"
                            class="mr-1 min-width-none"
                            @click="showUpdateModal(row.item.id)"
                            v-b-tooltip.hover
                            :title="$t('common.edit')"
                        >
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button
                            variant="danger"
                            @click="confirmDelete(row.item.id)"
                            v-b-tooltip.hover
                            class="min-width-none"
                            :title="$t('common.delete')"
                        >
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>
                    <template v-slot:empty>
                        <div class="text-center">
                            <span>Không tìm thấy bản ghi nào</span>
                        </div>
                    </template>
                </b-table>
                <div v-if="totalUserRows > CONSTANTS.AUDIT_ITEM_PER_PAGE" class="my-1">
                    <b-pagination
                        v-model="currentUserPage"
                        :total-rows="totalUserRows"
                        :per-page="CONSTANTS.AUDIT_ITEM_PER_PAGE"
                        :hide-goto-end-buttons="true"
                        :prev-text="$t('common.prevPage')"
                        :next-text="$t('common.nextPage')"
                        class="my-0"
                        align="center"
                    />
                </div>
            </b-card>

            <!-- List histories -->
            <b-card border-variant="light" class="card-doc">
                <b-card-title class="font-18 font-weight-bold">Lịch sử gửi tin</b-card-title>
                <b-table
                    class="mt-2"
                    striped
                    hover
                    :items="listHistories"
                    :fields="historyFields"
                    show-empty
                    :current-page="currentPage"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template v-slot:cell(index)="data">{{
                        (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                    }}</template>
                    <template v-slot:cell(createdAt)="data">
                        <span>{{ data.value | formatDateTime }}</span>
                    </template>
                    <template v-slot:cell(smsUserId)="row">
                        <span>{{ userName[row.value] }}</span>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge
                            class="px-2 py-1 font-12"
                            :variant="row.item.status === 'SUCCESS' ? 'success' : 'secondary'"
                            >{{
                                row.item.status === 'SUCCESS' ? 'THÀNH CÔNG' : 'THẤT BẠI'
                            }}</b-badge
                        >
                    </template>
                    <template v-slot:cell(confirm)="row">
                        <b-badge
                            class="px-2 py-1 font-12"
                            :variant="row.item.status === 'SUCCESS' ? 'primary' : 'light'"
                            >{{ row.item.status === 'SUCCESS' ? 'ĐÃ XEM' : 'CHƯA XEM' }}</b-badge
                        >
                    </template>
                    <template v-slot:empty>
                        <div class="text-center">
                            <span>Không tìm thấy bản ghi nào</span>
                        </div>
                    </template>
                </b-table>
                <div v-if="totalHistoryRows > CONSTANTS.AUDIT_ITEM_PER_PAGE" class="my-1">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalHistoryRows"
                        :per-page="CONSTANTS.AUDIT_ITEM_PER_PAGE"
                        :hide-goto-end-buttons="true"
                        :prev-text="$t('common.prevPage')"
                        :next-text="$t('common.nextPage')"
                        class="my-0"
                        align="center"
                    />
                </div>
            </b-card>
        </div>
        <!-- Create/Edit User Info -->
        <b-modal
            ref="createOrUpdateModal"
            :ok-title="`${itemInfo.id ? $t('common.update') : $t('common.create')}`"
            :title="`${itemInfo.id ? 'Cập nhật thông tin người nhận' : 'Tạo mới người nhận'}`"
            :cancel-title="$t('common.cancel')"
            @ok="handleCreateOk"
            no-close-on-esc
            no-close-on-backdrop
        >
            <b-form-group :label="$t('common.name')">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.name"
                    :placeholder="$t('common.name')"
                />
            </b-form-group>
            <b-form-group label="Mô tả">
                <b-form-textarea
                    maxlength="255"
                    v-model="itemInfo.description"
                    placeholder="Mô tả"
                />
            </b-form-group>
            <b-form-group label="Email">
                <b-form-input maxlength="255" v-model="itemInfo.email" placeholder="Email" />
            </b-form-group>
            <b-form-group label="Điện thoại">
                <b-form-input maxlength="255" v-model="itemInfo.phone" placeholder="Điện thoại" />
            </b-form-group>
        </b-modal>

        <!-- Edit Temp Info -->
        <b-modal
            ref="updateTempModal"
            ok-title="Cập nhật"
            :title="`${tempInfo.type == 'Cảnh báo lũ' ? 'Cảnh báo lũ' : 'Cảnh báo mưa'}`"
            :cancel-title="$t('common.cancel')"
            @ok="onSaveTemp"
            no-close-on-esc
            no-close-on-backdrop
        >
            <b-form-group label="Nội dung tin nhắn">
                <b-form-textarea maxlength="255" rows="3" v-model="tempInfo.template" />
            </b-form-group>
            <div class="text-danger">
                <span v-if="tempInfo.type == 'Cảnh báo lũ'">
                    Lưu ý: Nội dung tin nhắn phải bắt buộc có 3 cụm ký tự <strong>%s</strong> là tên
                    trạm tương ứng, <strong>%.2f</strong> hoặc <strong>%f</strong> tương ứng với giá
                    trị mực nước tại trạm và <strong>%d</strong> là cấp độ cảnh báo mực nước tại
                    trạm
                </span>
                <span v-else>
                    Lưu ý: Nội dung tin nhắn phải bắt buộc có 2 cụm ký tự <strong>%s</strong> là tên
                    trạm tương ứng và <strong>%.2f</strong> hoặc <strong>%f</strong> tương ứng với
                    giá trị mực nước tại trạm
                </span>
            </div>
        </b-modal>

        <!-- Confirm Delete -->
        <b-modal
            ref="deleteModal"
            :title="$t('common.confirmation')"
            no-close-on-esc
            no-close-on-backdrop
            :ok-title="$t('common.delete')"
            :cancel-title="$t('common.cancel')"
            ok-variant="danger"
            @ok="onDelete"
            >Bạn có chắc chắn muốn người nhận này?</b-modal
        >
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
export default {
    mounted: function () {
        this.$nextTick(function () {
            this.getListUser();
            this.getSmsHistory();
            this.getListSmsTemplate();
        });
    },
    data: function () {
        return {
            sortBy: 'createdAt',
            sortDesc: true,
            userFields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'name', label: this.$i18n.t('common.name') },
                { tdClass: 'align-middle', key: 'description', label: 'Mô tả' },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    tdClass: 'align-middle',
                    key: 'actions',
                    label: 'Thao tác'
                }
            ],
            historyFields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'name', label: this.$i18n.t('common.name') },
                { tdClass: 'align-middle', key: 'smsUserId', label: 'Người nhận' },
                { tdClass: 'align-middle', key: 'status', label: 'Trạng thái' },
                { tdClass: 'align-middle', key: 'confirm', label: 'Xác nhận' },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                }
            ],
            tempFields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'template', label: 'Mẫu' },
                { tdClass: 'align-middle', key: 'type', label: 'Loại' },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    tdClass: 'align-middle',
                    key: 'actions',
                    label: 'Thao tác'
                }
            ],
            CONSTANTS,
            currentPage: 1,
            currentTempPage: 1,
            currentUserPage: 1,
            itemInfo: {},
            tempInfo: {}
        };
    },
    computed: {
        ...mapState({
            listUsers: (state) => state.sms.listUsers,
            listTemps: (state) => state.sms.listTemps,
            temp: (state) => state.sms.temp,
            user: (state) => state.sms.user,
            listHistories: (state) => state.sms.listHistories
        }),
        totalUserRows() {
            return this.listUsers.length;
        },
        totalHistoryRows() {
            return this.listHistories.length;
        },
        totalTempRows() {
            return this.listTemps.length;
        },
        userName() {
            const user = {};
            this.listUsers.forEach((element) => {
                user[element.id] = element.name;
            });
            return user;
        }
    },
    methods: {
        ...mapActions({
            getListUser: 'sms/getListUser',
            getUserInfo: 'sms/getUserInfo',
            getSmsTemplate: 'sms/getSmsTemplate',
            getSmsHistory: 'sms/getSmsHistory',
            updateOrCreate: 'sms/updateOrCreateUser',
            updateTemp: 'sms/updateTemp',
            getListSmsTemplate: 'sms/getListSmsTemplate',
            getSmsTemplate: 'sms/getSmsTemplate',
            createAuditByUser: 'user/createAuditByUser',
            deleteById: 'sms/deleteUser'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        async onSaveTemp(modal) {
            modal.preventDefault();
            if (
                !this.tempInfo.template ||
                !(
                    this.tempInfo.template.includes('%s') &&
                    (this.tempInfo.template.includes('%f') ||
                        this.tempInfo.template.includes('%.2f'))
                )
            ) {
                this.$toaster.error('Vui lòng cập nhật lại nội dung tin nhắn theo mô tả');
                return;
            }
            await this.updateTemp(this.tempInfo);
            this.$refs.updateTempModal.hide();
            this.createAuditByUser({ content: 'Sửa tin nhắn' });
            this.$toaster.success('Cập nhật tin nhắn thành công');
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.itemInfo.id) {
                        this.update();
                    } else {
                        this.add();
                    }
                    this.$refs.createOrUpdateModal.hide();
                    this.createAuditByUser({ content: 'Tạo/sửa người nhận tin nhắn' });
                    this.$toaster.success(
                        `${
                            this.user.id
                                ? this.$i18n.t('common.update')
                                : this.$i18n.t('common.create')
                        } người nhận tin nhắn thành công`
                    );
                }
            });
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateModal.show();
        },
        async showUpdateModal(id) {
            this.resetForm();
            await this.getUserInfo({ id: id });
            this.itemInfo = { ...this.user };
            this.$refs.createOrUpdateModal.show();
        },
        async showUpdateTempModal(id) {
            await this.getSmsTemplate({ id: id });
            this.tempInfo = { ...this.temp };
            this.$refs.updateTempModal.show();
        },
        async add() {
            delete this.itemInfo.id;
            await this.updateOrCreate(this.itemInfo);
        },
        async update() {
            await this.updateOrCreate(this.itemInfo);
        },
        async onDelete(modal) {
            modal.preventDefault();
            await this.deleteById({ id: this.currentId });
            if (this.listUsers.length / this.CONSTANTS.ITEM_PER_PAGE === this.currentUserPage - 1) {
                this.currentUserPage--;
            }
            this.$refs.deleteModal.hide();
            this.createAuditByUser({ content: 'Xoá người nhận tin nhắn' });
        },
        async confirmDelete(id) {
            this.currentId = id;
            this.$refs.deleteModal.show();
        },
        resetForm() {
            this.itemInfo = {};
        }
    }
};
</script>
